
import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Row, Col, Button, Pagination } from "react-bootstrap";
import ShopAdds from "../shopAds/ShopAdds";
import { useLocation, useNavigate } from "react-router-dom";
import RedoIcon from "@mui/icons-material/Redo";
import "./shopItems.css";
import SalesPromotion from "../../components/SalesPromotion/SalesPromotion";
import SpecialOffer from "../../components/specialoffer/SpecialOffer";
import { useShopItemsData } from "../../hooks/useShopItemsData";

import ReportBox from "../Report/index";
import ShopCategory from "../Category";
import Suggestionmodal from "../../pages/suggestionmodal";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";

import Suggestion from "../../pages/suggestion";
import ShareOption from "../Shareoption";
import ShareModel from "../Sharemodel";
import { getAsset } from "../../helpers/helper";
import Loader from "../Loader";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import GradeIcon from "@mui/icons-material/Grade";
import { useSelector } from "react-redux";
import MainModal from "../ui/modal/modal";
import { decodeId, encodeShareId } from "../../utils/idObfuscator";
import { useGetMyManagedShopsQuery } from "../../features/shop/shopMemberApiSlice";

const OwnerItemShop = ({
  shopid,
  urlPass,
  btnName,
  names,
  navigateto,
  updateState,
  setSuggest,
  suggest,
  Setreport,
  Report,
  post,
  suggestdata,
  shopData,
}) => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  const [itemid, setItemid] = useState();
  const location = useLocation();
  const [linktoshare, setLinktoshare] = useState("");
  const [showmodal, setShowmodal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const itemsPerPage = 30; // Limit to 50 items (items + dummy) per page
  const handleClose = () => setShows(0);

  const {
    itemsData,
    itemsFetching,
    purchaseData,
    isLoadingPurchase,
    marketerData,
    deleteShopItem,
  } = useShopItemsData(shopid, name?._id);

  const itemshow = itemsData?.regular || [];
  const specialoffer = itemsData?.specialoffer || [];
  const salepromotion = itemsData?.salespromotion || [];

  useEffect(() => {
  }, [itemshow]);

  // Calculate total items (itemshow + dummy items) and pages
  const totalItems = Math.max(itemshow?.length || 0, 100); // At least 100 items (items or dummy)
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate the items to display for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = itemshow?.slice(indexOfFirstItem, indexOfLastItem);
  const currentDummyCount = Math.max(0, 100 - (currentItems?.length || 0));

  const [isMarketerHandeling, SetisMarketerHandeling] = useState(() => {
    const marketerId = localStorage.getItem("MeAsmarketerId");
    const previousRoute = localStorage.getItem("previousRoute");
    return previousRoute === "marketing-clients" && marketerId !== null;
  });

  const loadingPlan = isMarketerHandeling && isLoadingPurchase;
  const marketerUserId = localStorage.getItem("MeAsmarketerUserId");
  const userId = name?._id?.toString();

  // Override condition (full access if IDs match)
  const isOwnerOverride = marketerUserId && userId && marketerUserId === userId;
  const shopUserId =
    shopData?.userid?._id?.toString?.() || shopData?.userid?.toString?.();
  const isOwner = Boolean(userId && shopUserId && shopUserId === userId);

  const plans = ["Free", "Basic", "Standard", "Premium"];
  const planData = purchaseData?.data || purchaseData;
  const planName = planData?.planId?.planName;
  const currentPlan = plans.includes(planName) ? planName : null;
  const isHiredSuccess = planData?.paymentStatus === "success";

  const cleanShopId = decodeId(shopid) || shopid || "";
  const { data: managedShopsRes } = useGetMyManagedShopsQuery(undefined, {
    skip: !userId || isOwner,
  });

  const currentMembership = (managedShopsRes?.data?.managedShops || []).find(
    (m) => {
      const sId = m?.shopId?._id || m?.shopId;
      return (
        sId &&
        (String(sId) === String(cleanShopId) ||
          String(sId) === String(shopid))
      );
    },
  );

  const isManagedMember = Boolean(currentMembership);
  const memberAccessAreas = currentMembership?.accessAreas || [];

  const canManageItems =
    isOwner ||
    isOwnerOverride ||
    (isManagedMember && memberAccessAreas.includes("post-edit-items"));

  const canPostItems =
    Boolean(post) &&
    (canManageItems ||
      (!isManagedMember &&
        isHiredSuccess &&
        (currentPlan === "Standard" || currentPlan === "Premium")));

  // BUG FIXED: this used to require currentPlan === "Premium" to grant any
  // access at all, while `canPostItems` (below) already allowed posting for
  // "Standard" plan clients too. Since the whole items section — including
  // the "Post Item" tab — only renders when `canAccess` is true, a marketer
  // handling a Standard-plan client could never reach the posting tab in
  // the first place; they only ever saw the "Upgrade to Premium" message.
  // Aligning the threshold here with `canPostItems` makes Standard-plan
  // access actually reachable, matching the intent already coded below.
  const canAccess =
    isOwner ||
    isOwnerOverride || // 🔥 override comes first
    isMarketerHandeling === false ||
    (isMarketerHandeling === true &&
      isHiredSuccess &&
      (currentPlan === "Standard" || currentPlan === "Premium"));

  const shouldShowUpgrade =
    userId && shopData && // Only evaluate when user and shop data are fully loaded
    !isOwner &&
    !isOwnerOverride && // 🚫 hide upgrade if override applies
    isMarketerHandeling === true &&
    !(isHiredSuccess && (currentPlan === "Standard" || currentPlan === "Premium"));

  const [showshare, setShowshare] = useState(false); // timeline share muzzamal
  const [showcategory, setShowcategory] = useState(0);
  const [suggestId, setSuggestId] = useState();
  const [shows, setShows] = useState(false);

  localStorage.setItem("suggestid", suggestId);

  useEffect(() => {
    if (
      location.pathname.includes(`/rawmaterial-owner-profile/${shopid}`) ||
      location.pathname.includes(`/manufacturer-owner-profile/${shopid}`) ||
      location.pathname.includes(`/wholesaler-owner-profile/${shopid}`) ||
      location.pathname.includes(`/recycle-profile/${shopid}`)
    ) {
      const salesTab = document.getElementById("uncontrolled-tab-example-tab-sales");
      const specialTab = document.getElementById("uncontrolled-tab-example-tab-special");
      if (salesTab) salesTab.style.visibility = "hidden";
      if (specialTab) specialTab.style.visibility = "hidden";
    }
  }, [location.pathname, shopid]);

  useEffect(() => {
    // Component mounted or itemshow changed
  }, [itemshow]);

  const handleSelect = (key) => {
    if (key === "tab1") {
      navigate(navigateto);
    } else if (key === "post") {
      navigate(post);
    }
  };

  const handledelete = async () => {
    try {
      const res = await deleteShopItem(itemid).unwrap();
      if (res?.success) {
        setShows(false);
        SuccessNotify("Item deleted successfully");
      }
    } catch (err) {
      FailedNotify("Failed to delete item");
    }
  };

  const handleCloseshare = () => {
    setShowshare(0);
  };

  const handleShowshare = () => {
    setShowshare(1);
  };

  const closemodal = () => setShowmodal(false);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top on page change
  };

  const handleShareClick = (itemId) => {
    if (!urlPass || !shopid || !itemId) {
      console.warn("Missing data for link generation");
      return;
    }

    // Use human-readable shopid if available, otherwise fallback to MongoDB _id
    const readableShopId = shopData?.shopid || shopid;
    const generatedLink = `${urlPass}/${readableShopId}/${encodeShareId(itemId)}`;
    setLinktoshare(generatedLink);
    setShowmodal(true);
  };

  // Combine items and dummy items
  const renderItems = () => {
    const items = [];

    // Add actual items
    if (currentItems?.length > 0) {
      currentItems.forEach((Items, itemIndex) => {
        items.push(
          <div
            className="col-lg-4 col-xl-3 col-md-6 col-6 p-2"
            key={Items?._id || Items?.id || `item-${indexOfFirstItem + itemIndex}`}
          >
            <div className="border_2 mt-2 rounded">
              <div>
                <div className="fix-img">
                  <img
                    className="c_img"
                    src={Items?.images && Items.images[0] && Items.images[0] !== "" ? getAsset(Items.images[0]) : noImagePlaceholder}
                    alt=""
                    crossOrigin="anonymous"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = noImagePlaceholder;
                    }}
                  />
                </div>
                <Row className="align-items-center">
                  <Col lg={6} md={5} xs="6" sm="6" className="pe-0">
                    <div className="pt-1 ms-2">
                      <p className="mb-0 ps-2 pe-2 items-card-font fw-bold">
                        {Items?.itemname?.slice(0, 7) || "No Name"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} md={7} xs="6" sm="6" className="ps-0 pe-4">
                    <div>
                      <p className="mb-0 ps-2 labelText fw-bold pt-1 ms-2 ms-lg-1 text-end">
                        Qty ({Items?.quantity})
                      </p>
                    </div>
                  </Col>
                </Row>
                <div className="d-flex justify-content-between align-items-center ps-2 pe-2">
                  <p className="mb-0 pt-1 items-card-font font-blue ms-2">
                    <span style={{ color: "black" }}>Price:</span>&nbsp;
                    {Items?.price}
                  </p>
                  <div style={{ color: "black", fontSize: "12px" }}>
                    <b>
                      <GradeIcon
                        style={{
                          fontSize: "medium",
                          color: "#FFE507",
                        }}
                      />
                      ({Items?.rating ? Number(Items.rating).toFixed(1) : "0.0"})
                    </b>
                  </div>
                </div>
                <div className="row align-items-center">
                  <Col lg="6" xs="6" md="6" sm="6" className="pe-0">
                    <h6 className="items-card-font ms-3 mb-0">Orders ({Items?.orders || 0})</h6>
                  </Col>
                  <Col lg="6" xs="6" md="6" sm="6" className="text-center">
                    <button
                      className="text-white bg-blue share_font item-share-btn"
                      onClick={() => handleShareClick(Items._id)}
                    >
                      Share
                      <RedoIcon className="share_icon_f" />
                    </button>
                  </Col>
                </div>
                <div className="d-flex justify-content-around mb-2 mt-1">
                  <p
                    className="mb-0 view-btn btn-primary text-center ms-1 me-1 mt-1"
                    onClick={() =>
                      navigate(`${urlPass}/${shopid}/${Items._id}`)
                    }
                  >
                    View
                  </p>
                  {canManageItems && (
                    <Button
                      className="mb-0 view-btnone text-white text-center ms-1 me-1 mt-1"
                      variant="danger"
                      onClick={() => {
                        setShows(true);
                        setItemid(Items._id);
                      }}
                    >
                      Delete
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>,
        );
      });
    }

    // Add dummy items
    Array.from({ length: currentDummyCount }).forEach((_, index) => {
      items.push(
        <div
          className="col-lg-4 col-xl-3 col-md-6 col-6 p-2"
          key={`dummy-${index}-${indexOfFirstItem}`}
        >
          <div className="border_2 rounded mt-2">
            <div>
              <img
                className="c_img"
                src={dummyezi}
                alt="Dummy Item"
                style={{ objectFit: "cover", height: "100%", width: "100%" }}
              />

              <div className="text-center pt-2 pb-2">
                <p
                  className="mb-0 items-card-font fw-bold pb-1"
                  style={{ color: "#0353a4" }}
                >
                  Post item to see here
                </p>
              </div>
            </div>
          </div>
        </div>,
      );
    });

    return items;
  };

  const suggestsingleid = localStorage.getItem("suggestid");

  useEffect(() => {
    if (marketerData?.data?.[0]) {
      const marketer = marketerData.data[0];
      localStorage.setItem("MeAsmarketerId", marketer?._id);
      localStorage.setItem("MeAsmarketerUserId", marketer?.userId?._id);
    }
  }, [marketerData]);

  useEffect(() => {
    const marketerId = localStorage.getItem("MeAsmarketerId");
    const previousRoute = localStorage.getItem("previousRoute");
    const isHandling = previousRoute === "marketing-clients" && marketerId !== null;
    SetisMarketerHandeling(isHandling);
  }, []);

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        handleClosemodal={closemodal}
        handleShowshare={handleShowshare}
        shareurl={linktoshare}
      />
      <MainModal
        variant="deleteModal"
        show={shows}
        handleClose={handleClose}
        handledelete={handledelete}
      />
      <Col lg={12}>
        <ShopAdds back="/SellingSide" updateState={updateState} />

        {loadingPlan ? (
          <Loader heightsetting="screenHeight" />
        ) : canAccess ? (
          <>
            {/* ALL YOUR MAIN CONTENT HERE */}
            <div onBlur={() => setShowcategory(0)}>
              <Row>
                <Col lg={12}>
                  {suggest === 1 ? (
                    <Suggestionmodal
                      setSuggestId={setSuggestId}
                      setSuggest={setSuggest}
                      suggest={suggest}
                      suggestdata={suggestdata}
                      shopid={shopid}
                      shopData={shopData}
                    />
                  ) : suggest === 2 ? (
                    <ReportBox
                      setSuggest={setSuggest}
                      suggest={suggest}
                      shopid={shopid}
                    />
                  ) : suggest === 3 ? (
                    <Suggestion
                      suggestsingleid={suggestsingleid}
                      suggestdata={suggestdata}
                      shopData={shopData}
                      setSuggest={setSuggest}
                      shopid={shopid}
                    />
                  ) : (
                    <Tabs
                      id="uncontrolled-tab-example"
                      className="mb-3 ps-lg-5 tabsajdust"
                      onSelect={handleSelect}
                    >
                      <Tab
                        eventKey="jobs"
                        title="Regular items"
                        className="jobviewhead"
                      >
                        {showcategory === 1 && <ShopCategory />}
                        <div className="shop-scroll noscroll">
                          <div className="items_scroll noscroll">
                            <div className="row ps-2 pe-2">
                              {itemsFetching ? (
                                <Loader heightsetting="screenHeight" />
                              ) : (
                                <>
                                  {renderItems()}
                                  {!itemsFetching &&
                                    currentItems?.length === 0 &&
                                    currentDummyCount === 0 && (
                                      <h4 className="text-center">
                                        No items found
                                      </h4>
                                    )}
                                </>
                              )}
                            </div>
                            {totalPages > 1 && (
                              <div className="d-flex justify-content-center mt-4">
                                <Pagination>
                                  <Pagination.Prev
                                    onClick={() =>
                                      handlePageChange(currentPage - 1)
                                    }
                                    disabled={currentPage === 1}
                                  />
                                  {Array.from(
                                    { length: totalPages },
                                    (_, index) => (
                                      <Pagination.Item
                                        key={index + 1}
                                        active={index + 1 === currentPage}
                                        onClick={() =>
                                          handlePageChange(index + 1)
                                        }
                                      >
                                        {index + 1}
                                      </Pagination.Item>
                                    ),
                                  )}
                                  <Pagination.Next
                                    onClick={() =>
                                      handlePageChange(currentPage + 1)
                                    }
                                    disabled={currentPage === totalPages}
                                  />
                                </Pagination>
                              </div>
                            )}
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="sales" title="Sales Promotion">
                        <SalesPromotion
                          salepromotion={salepromotion}
                          setShowmodal={setShowmodal}
                          handleShareClick={handleShareClick}
                          urlPass={urlPass}
                          setShows={setShows}
                          setItemid={setItemid}
                          shopid={shopid}
                        />
                      </Tab>
                      <Tab eventKey="special" title="Special Offers">
                        <SpecialOffer
                          specialoffer={specialoffer}
                          setShowmodal={setShowmodal}
                          handleShareClick={handleShareClick}
                          urlPass={urlPass}
                          setShows={setShows}
                          setItemid={setItemid}
                          shopid={shopid}
                        />
                      </Tab>
                      {canPostItems && (
                        <Tab
                          eventKey="post"
                          title="&#10133; Post Item"
                          onClick={() => navigate(post)}
                        ></Tab>
                      )}
                    </Tabs>
                  )}
                </Col>
              </Row>
            </div>
          </>
        ) : shouldShowUpgrade ? (
          <>
            <div className="text-center mt-5">
              <h3 className="mb-3" style={{ color: "red" }}>
                Upgrade to Standard or Premium Plan to access this feature
              </h3>
            </div>
          </>
        ) : null}
      </Col>
    </>
  );
};

export default OwnerItemShop;
